import React, { useState } from 'react'
import PropTypes from 'prop-types'
import Dropdown from 'react-bootstrap/Dropdown'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus, faCog, faDownload } from '@fortawesome/free-solid-svg-icons'
import ShieldLogo from 'assets/Shield/White/ThirdLine Shield White.svg'
import SodExport from 'duties/shared/Export'
import RoleTypeSettings from './RoleTypeSettings'

// Consolidates the Roles index header actions — Build Role, Assign Role Types,
// and Export — into a single Actions dropdown matching the Roles#show and
// Employees#show pattern.
function ActionsDropdown({ filterParams, setShowBuilder }) {
  const [showExport, setShowExport] = useState(false)
  const [showRoleTypes, setShowRoleTypes] = useState(false)

  return (
    <React.Fragment>
      <Dropdown className="d-inline-block">
        <Dropdown.Toggle variant="primary" id="roles-actions-dropdown">
          <img
            src={ShieldLogo}
            alt=""
            className="me-2"
            style={{ height: '1.5em', verticalAlign: '-0.4em' }}
          />
          Actions
        </Dropdown.Toggle>
        <Dropdown.Menu align="end">
          <Dropdown.Item onClick={() => setShowBuilder(true)}>
            <FontAwesomeIcon
              icon={faPlus}
              fixedWidth
              className="me-2 text-muted"
            />
            Build Role
          </Dropdown.Item>
          <Dropdown.Item onClick={() => setShowRoleTypes(true)}>
            <FontAwesomeIcon
              icon={faCog}
              fixedWidth
              className="me-2 text-muted"
            />
            Assign Role Types
          </Dropdown.Item>
          <Dropdown.Divider />
          <Dropdown.Item onClick={() => setShowExport(true)}>
            <FontAwesomeIcon
              icon={faDownload}
              fixedWidth
              className="me-2 text-muted"
            />
            Export
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>

      <RoleTypeSettings
        show={showRoleTypes}
        setShow={setShowRoleTypes}
        hideTrigger
      />
      <SodExport
        params={filterParams}
        defaultName="Roles"
        source="roles"
        show={showExport}
        setShow={setShowExport}
        hideTrigger
      />
    </React.Fragment>
  )
}

ActionsDropdown.propTypes = {
  filterParams: PropTypes.object.isRequired,
  setShowBuilder: PropTypes.func.isRequired
}

export default ActionsDropdown
